import type { FaireProductEntity } from "../../entity_types/product";

export const p_fcg9kf5dr5: FaireProductEntity = {
  token: "p_fcg9kf5dr5",
  type: "product",
  name: "Let That Shit Go Funny Ladies' Novelty Crew Socks",
  brandToken: "b_6nu7ayhqaw",
  brandName: "Fabdaz",
  imageUrl:
    "https://cdn.faire.com/fastly/86f3735fa24a2f031d45c02805b0dda9f6c68a8d5962a912975f920fcf10e45d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5fa9f087331811a49b44743ce55f25332cdc7a764db0b97ee35e1dad0e0c01c2.jpeg",
    "https://cdn.faire.com/fastly/f5002eef925d93fddb6456c134c8b78f55bca5190e93893faa15668fb951e958.jpeg",
    "https://cdn.faire.com/fastly/4f14ea29293f61c2b41a6e0a2b8b2e1de361894ef3b7ea5ae447c6f2777d55be.jpeg",
  ],
  priceDollars: 3.5,
  description:
    "Sassy Women's Crew Socks \"Let That Shit Go\" meditating frog.\nStylish and comfortable!\n• Fits ladies' shoe size 5 to 10.\n• 80% Cotton, 15% Nylon, 5% Spandex.\n• Easy Care - Machine Wash.\n• Item # SK0153\n• Packed on card peg hook ready, UPC coded.\n• Designed in Chattanooga, TN by our in-house.",
  tags: [],
  msrpDollars: 12.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:38.069Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
